var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},_vm._l((_vm.list),function(item){return _c('el-table-column',{key:item.value,attrs:{"prop":item.value,"label":item.label,"formatter":_vm.autoFormatter}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }